'use client';

import useOperatingSystem from '@/hooks/use-operating-system';

function OptionAltKey() {
  const os = useOperatingSystem();

  return os === 'mac' ? '⌥' : 'Alt';
}

export default OptionAltKey;
